import API from './API'

export default {
  // load single proje
  endTrial: function(subscription_id) {
    return API.post(`/api/subscriptions/${subscription_id}/upgrade`);
  },
};
